import * as Yup from 'yup'
import {
  createValidation,
  DocumentoPessoaType,
  NotificacaoType,
} from '../../../../../../../../_metronic/helpers'
import { TFunction } from '_metronic/i18n/Metronici18n'

type DocumentoTipo = {
  label: string
  value: DocumentoPessoaType
}

export const interconsultaSchema = (
  t: TFunction,
  isAtendimento: boolean = false,
  /** Solicitante com mais de uma lotação vigente na unidade: precisa escolher qual carimbar. */
  exigeLotacao: boolean = false
) => {
  const v = createValidation(t)
  return Yup.object().shape({
    empresa: Yup.object().nullable().required(v.requiredField('empresa', 'select')),

    sexo: Yup.object()
      .nullable()
      .when('id', {
        is: (id: number) => !id,
        then: (schema) => schema.required('Selecione um gênero'),
        otherwise: (schema) => schema.notRequired(),
      }),

    id: Yup.number().nullable(),

    primeiroNome: Yup.string()
      .min(3, 'Minimo de 3 caracteres')
      .max(50, 'Máximo de 50 caracteres')
      .test(
        'not-empty',
        'Campo não pode conter apenas espaços',
        (value) => typeof value === 'string' && value.trim().length > 0
      )
      .when('id', {
        is: (id: number) => !id,
        then: (schema) => schema.required('O campo nome é obrigatório'),
        otherwise: (schema) => schema.notRequired(),
      }),

    sobreNome: Yup.string()
      .min(3, 'Minimo de 3 caracteres')
      .max(50, 'Máximo de 50 caracteres')
      .test(
        'not-empty',
        'Campo não pode conter apenas espaços',
        (value) => typeof value === 'string' && value.trim().length > 0
      )
      .when('id', {
        is: (id: number) => !id,
        then: (schema) => schema.required('O campo sobrenome é obrigatório'),
        otherwise: (schema) => schema.notRequired(),
      }),

    documento: Yup.object()
      .nullable()
      .when('id', {
        is: (id: number) => !id,
        then: (schema) => schema.required('O campo documento é obrigatório'),
        otherwise: (schema) => schema.notRequired(),
      }),

    cpf: Yup.string().when(['documento', 'id'], {
      is: (tipo: DocumentoTipo, id: number) => !id && tipo?.value === DocumentoPessoaType.Cpf,
      then: Yup.string()
        .matches(/^\d{3}\.\d{3}\.\d{3}-\d{2}$/, 'CPF inválido')
        .required('O campo CPF é obrigatório'),
      otherwise: (schema) => schema.notRequired(),
    }),

    cns: Yup.string().when(['documento', 'id'], {
      is: (tipo: DocumentoTipo, id: number) => !id && tipo?.value === DocumentoPessoaType.Cns,
      then: Yup.string().required('O campo CNS é obrigatório'),
      otherwise: (schema) => schema.notRequired(),
    }),

    passaporte: Yup.string().when(['documento', 'id'], {
      is: (tipo: DocumentoTipo, id: number) =>
        !id && tipo?.value === DocumentoPessoaType.Passaporte,
      then: Yup.string().required('O campo passaporte é obrigatório'),
      otherwise: (schema) => schema.notRequired(),
    }),

    bilheteIdentidadeAngola: Yup.string().when(['documento', 'id'], {
      is: (tipo: DocumentoTipo, id: number) =>
        !id && tipo?.value === DocumentoPessoaType.BilheteIdentidadeAngola,
      then: Yup.string().required('O campo Bilhete de Identidade Nacional é obrigatório'),
      otherwise: (schema) => schema.notRequired(),
    }),

    nascimento: Yup.string().when('id', {
      is: (id: number) => !id,
      then: (schema) => schema.required('O campo data de nascimento é obrigatório'),
      otherwise: (schema) => schema.notRequired(),
    }),

    unidade: Yup.object().nullable().notRequired(),
    lotacaoSolicitante:
      isAtendimento && exigeLotacao
        ? Yup.object().nullable().required('Selecione a sua lotação')
        : Yup.object().nullable().notRequired(),

    modalidade: isAtendimento
      ? Yup.string().required('Modalidade de atendimento é obrigatória')
      : Yup.string().notRequired(),

    especialidade: isAtendimento
      ? Yup.object().nullable().required('Especialidade é obrigatória')
      : Yup.object().nullable().notRequired(),

    tipoNotificacao: Yup.string().nullable().notRequired(),

    telefone: Yup.string()
      .matches(
        /^\(\d{2}\) (\d )?\d{4}-\d{4}$/,
        'Formato deve ser (00) 0000-0000 ou (00) 0 0000-0000'
      )
      .when('tipoNotificacao', {
        is: (val: string) => val === NotificacaoType.Whatsapp || val === NotificacaoType.Ambos,
        then: (schema) => schema.required('Telefone é obrigatório para notificação via WhatsApp'),
        otherwise: (schema) => schema.notRequired(),
      }),
  })
}
